module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-form/pay-monthly-form.component.css
// module id = ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-form/pay-monthly-form.component.css
// module chunks = main